import React, { useState } from 'react';
import { Image as ImageIcon, X, ZoomIn, Upload, AlertCircle, Camera } from 'lucide-react';
import { galleriaFoto } from '../data/mock';
import SocialShare from '../components/SocialShare';

export default function Gallery() {
  const [lightbox, setLightbox] = useState(null);
  const [filter, setFilter] = useState('Tutte');

  const categorie = ['Tutte', ...Array.from(new Set(galleriaFoto.map((f) => f.categoria)))];
  const filtered = filter === 'Tutte' ? galleriaFoto : galleriaFoto.filter((f) => f.categoria === filter);

  return (
    <div className="bg-navy min-h-screen">
      <section className="relative py-24">
        <div className="absolute inset-0 bg-gradient-to-b from-navy-dark to-navy"></div>
        <div className="relative max-w-5xl mx-auto px-4 lg:px-8 text-center">
          <Camera size={46} className="text-pink-brand mx-auto mb-4" />
          <h1 className="font-brand text-5xl md:text-6xl font-bold text-white mb-4">Galleria Foto</h1>
          <div className="w-24 h-1 bg-pink-brand mx-auto rounded"></div>
          <p className="text-white/70 mt-6 max-w-2xl mx-auto">
            Le immagini più belle della serata finale, delle partite e dei momenti speciali del Memorial.
          </p>
          <div className="mt-6 flex justify-center">
            <SocialShare title="Galleria foto — Memorial Eugenio Abbro" />
          </div>
        </div>
      </section>

      <section className="pb-6">
        <div className="max-w-6xl mx-auto px-4 lg:px-8">
          <div className="flex flex-wrap gap-2 justify-center">
            {categorie.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                className={`px-5 py-2.5 rounded-full text-xs font-bold uppercase tracking-wider transition-all ${
                  filter === c ? 'bg-pink-brand text-white shadow-md' : 'bg-navy-dark text-white/70 hover:text-white border border-white/10'
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="pb-10">
        <div className="max-w-6xl mx-auto px-4 lg:px-8">
          {filtered.length === 0 ? (
            <div className="glass-card p-10 text-center">
              <ImageIcon size={40} className="text-white/30 mx-auto mb-3" />
              <p className="text-white/70">Nessuna foto ancora disponibile in questa categoria</p>
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {filtered.map((foto) => (
                <button
                  key={foto.id}
                  onClick={() => setLightbox(foto)}
                  className="relative aspect-square overflow-hidden rounded-xl group"
                >
                  <img src={foto.src} alt={foto.titolo} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                    <div>
                      <div className="text-pink-brand text-[10px] font-bold uppercase tracking-widest">{foto.categoria}</div>
                      <div className="text-white font-semibold text-sm leading-tight">{foto.titolo}</div>
                    </div>
                  </div>
                  <div className="absolute top-3 right-3 w-9 h-9 rounded-full bg-pink-brand/90 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <ZoomIn size={16} />
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Info upload */}
      <section className="pb-20">
        <div className="max-w-4xl mx-auto px-4 lg:px-8">
          <div className="glass-card p-5 flex items-start gap-3">
            <Upload size={22} className="text-pink-brand flex-shrink-0 mt-0.5" />
            <div>
              <h3 className="text-white font-bold mb-1">Vuoi contribuire con le tue foto?</h3>
              <p className="text-white/70 text-sm">
                Invia le foto a <a href="mailto:memorialeugenioabbro@gmail.com" className="text-pink-brand hover:underline">memorialeugenioabbro@gmail.com</a> oppure chiedi accesso all’area admin per caricarle direttamente dal pannello.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4 animate-fade-in" onClick={() => setLightbox(null)}>
          <button className="absolute top-4 right-4 w-11 h-11 rounded-full bg-pink-brand text-white flex items-center justify-center" aria-label="Chiudi">
            <X size={22} />
          </button>
          <div className="max-w-5xl max-h-full w-full">
            <img src={lightbox.src} alt={lightbox.titolo} className="max-w-full max-h-[80vh] object-contain rounded-lg mx-auto" />
            <div className="mt-4 flex flex-col sm:flex-row items-center justify-between gap-3 text-white">
              <div>
                <div className="text-pink-brand text-xs font-bold uppercase tracking-widest">{lightbox.categoria} · {lightbox.data}</div>
                <div className="text-lg font-semibold">{lightbox.titolo}</div>
              </div>
              <SocialShare title={lightbox.titolo} compact />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
